import $ from 'jquery';
import globalNav from '@99designs/common/apps/global-nav';
import relativeTime from '@99designs/common/apps/global-nav/flight-js/ui/relative-time';
import '@99designs/common/jquery-plugins/media-query-label';

// Fix https://www.cve.mitre.org/cgi-bin/cvename.cgi?name=2015-9251
// More: https://github.com/jquery/jquery/issues/2432
// Can be removed if upgrading to jQuery 3
jQuery.ajaxPrefilter(s => {
    s.contents.script = false; // eslint-disable-line no-param-reassign
});

// Initialise asimov-media-query-label outside dom
// ready check below. It has its own check and we want
// this to fire early on.
$(document).mediaQueryLabel();

document.addEventListener('DOMContentLoaded', () => {
    relativeTime.attachTo('html', {
        locale: document.documentElement.lang,
    });
    globalNav();
});

// Send CSRF token with every AJAX request
// Adapted from https://github.com/rails/jquery-ujs
$.ajaxPrefilter((options, originalOptions, xhr) => {
    const token = $('meta[name="csrf-token"]').attr('content');
    if (token && !options.crossDomain) {
        xhr.setRequestHeader('X-CSRF-Token', token);
    }
});



// WEBPACK FOOTER //
// ./src/js/page/base.js